import { Button, Icon, Modal } from '@octano/global-ui';
import { useTranslation } from 'react-i18next';

interface Props {
  isOpen: boolean;
  onConfirm: () => void;
}

export default function CeNotCompletedModal({ isOpen, onConfirm }: Props) {
  const prefix = 'reports.errors.ceNotCompletedModal';
  const { t } = useTranslation();

  return (
    <Modal isOpen={isOpen} toggle={onConfirm || (() => {})}>
      <div className="d-flex flex-column align-items-center justify-content-center text-center py-3 px-4">
        <Icon name="error" size={50} className="mb-4" />
        <h1 className="fs-20 text-dark mt-2 mb-3">{t(`${prefix}.title`)}</h1>
        <p className="fs-18 text-light">{t(`${prefix}.description`)}</p>
        <Button
          fullwidth
          className="mt-5"
          text={t(`${prefix}.btnText`)}
          onClick={() => onConfirm()}
        />
      </div>
    </Modal>
  );
}
